
























import { InvoicesClient, PaymentDto } from "@/data/web-api-client";
import { CURRENCY_FORMAT } from "@/helpers/currency";
import DataSource from "devextreme/data/data_source";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import dxCustomStore from "devextreme/data/custom_store";
import paymentRepository from "@/modules/invoicing/services/paymentRepository";
import notificationService from "@/services/notificationService";
import {
  DxDataGrid,
  DxEditing,
  DxColumn,
  DxRequiredRule,
  DxStateStoring,
  DxColumnChooser,
  DxColumnFixing,
  DxFilterRow,
  DxLookup,
} from "devextreme-vue/data-grid";
import cCard from "@/components/default/Card.vue";
import Datagrid from "@/components/default/Datagrid.vue";
import { IPaymentDto, InvoiceDto } from "@/data/web-api-client";
import InvoicePaymentDialog from "./InvoicePaymentDialog.vue";

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxLookup,
    cCard,
    Datagrid,
    InvoicePaymentDialog,
  },
})
export default class InvoicePaymentTable extends Vue {
  @Prop({ required: false })
  public invoice!: InvoiceDto;

  @Prop({ required: false })
  public projectId!: string;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  public loading: boolean = false;
  public payments: IPaymentDto[] = [];
  public selectedPaymentId: string = "";
  private client: InvoicesClient = new InvoicesClient(undefined, this.$axios);

  datasource: DataSource = new DataSource({
    store: new dxCustomStore({
      key: "id",
      load: async (loadOptions) => {
        (loadOptions as any).stringToLower = true;
        const result = await paymentRepository.paymentLookUp(
          loadOptions,
          this.invoice ? this.invoice.id : undefined,
          this.projectId
        );
        return {
          data: result.data.data,
          totalCount: result.data.totalCount,
        };
      },
      byKey: async (val: any) => {
        return await this.client.getPayment(val);
      },
      remove: async (val: any) => {
        try {
          await this.client.removePayment(val);
          notificationService.saved();
        } catch (err) {
          notificationService.failedToSave();
        }
      },
    }),
    paginate: true,
  });

  public async mounted() {
    await this.loadData();
  }

  public async refreshData() {
		this.clearSelectedPayment();
  	this.$emit("refresh");
    await this.loadData();
		this.refreshGrid();
  }

  public refreshGrid() {
    try {
			(
        (this.$refs.grid as Datagrid).$refs.invoicePaymentTable as any
      ).instance.refresh();
		} catch {
      // do nothing
    }
	}

  public async loadData() {
    try {
      this.loading = true;
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

	clearSelectedPayment() {
		this.selectedPaymentId = '';
	}

  private openPaymentDialog(id: string) {
    this.selectedPaymentId = id;
    (this.$refs.paymentDialog as InvoicePaymentDialog).show = true;
  }

  get columns() {
    var numberColumn ={
				dataField: "invoiceNumber",
				caption: this.$t("objects.invoices.DocumentNumber"),
			};

    var defaultColumns: any[] = [
      {
        dataField: "ogm",
        caption: "OGM",
      },
      {
        dataField: "amount",
        caption: this.$t("objects.invoices.Amount"),
        format: CURRENCY_FORMAT,
        alignment: "left",
      },
      {
        dataField: "paymentDate",
        caption: "Betaaldatum",
        dataType: "date",
        format: "dd/MM/yyyy",
      }
    ];

		if ((!this.invoice || !this.invoice.id) && this.projectId){
			defaultColumns.unshift(numberColumn as any);
		}

    if (!this.disabled) {
      defaultColumns.push({
        type: "buttons",
        buttons: [
          {
            hint: "Betaling aanpassen",
            icon: "fas fa-edit",
            visible(e: any) {
              return e.row.data.invoiceId;
            },
            onClick: (e: any) => {
              this.openPaymentDialog(e.row.data.id);
            },
          },
          "delete",
        ],
      });
    }

    return defaultColumns;
  }

  @Watch("invoiceId", {immediate: false})
  @Watch("projectId", {immediate: false})
  private async onPropertyChanged(value: boolean, oldValue: boolean) {
		if (this.loading){
			return;
		}
    await this.loadData();
		this.refreshGrid();
  }
}
